import React, { useRef } from 'react';
import './warrantyViewTabs.scss';

export default function WarrantyViewTabs({ id, label, items, value, onChange, disabled }) {
  const buttons = useRef({});
  const enabled = items.filter(item => !item.disabled);
  const move = (event, key) => {
    if (disabled || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const index = enabled.findIndex(item => item.key === key);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1
      : (index + (event.key === 'ArrowRight' ? 1 : -1) + enabled.length) % enabled.length;
    if (enabled[next]) { onChange(enabled[next].key); buttons.current[enabled[next].key]?.focus(); }
  };
  return <div className='bw_warranty_view_tabs' role='tablist' aria-label={label}>
    {items.map(({ key, label: text, icon: Icon, count, panelId, disabled: unavailable }) => <button
      key={key} ref={node => { buttons.current[key] = node; }} type='button' role='tab'
      id={`${id}-tab-${key}`} aria-controls={panelId || `${id}-panel-${key}`} aria-selected={value === key}
      tabIndex={value === key ? 0 : -1} disabled={disabled || unavailable}
      onKeyDown={event => move(event, key)} onClick={() => onChange(key)}>
      {Icon && <Icon aria-hidden='true' />}<span>{text}</span>{count !== undefined && <small>{count}</small>}
    </button>)}
  </div>;
}
